var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as Raven from 'raven-js';
import { SharedModule } from './components/shared.module';
import { FeaturesModule } from './modules/features/features.module';
import { MixpanelService } from './mixpanel/mixpanel.service';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Ng2BootstrapModule } from 'ngx-bootstrap';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DashboardModule } from './dashboard/dashboard.module';
import { routing } from './app.routing';
//import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { BrandsResolver } from './resolvers/brands.resolver';
import { CountriesResolver } from './resolvers/countries.resolver';
import { ContentComponent } from './components/content.component';
import { NavigationComponent } from './components/navigation.component';
import { FooterComponent } from './components/footer.component';
import { HelpComponent } from './help/help.component';
import { CookieService } from 'ngx-cookie';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { OrderModule } from './order/order.module';
import { ContentLoggedOutModule } from './components/content-loggedout.module';
import { LocalStorageService } from './localstorage.service';
import { CurrentOrderService } from './order/currentOrder.service';
import { OrderService } from './order/order.service';
import { QrComponent } from './QR/qrcomponent.component';
Raven
    .config('https://486435a8eff14c2da3982206ef6496be@sentry.io/204091', {
    release: process.env.VERSION
})
    .install();
var RavenErrorHandler = (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        console.error(err);
        if (process.env.ENV == "production")
            Raven.captureException(err);
    };
    return RavenErrorHandler;
}());
export { RavenErrorHandler };
var AppModule = (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        NgModule({
            imports: [
                BrowserModule,
                FormsModule,
                routing,
                OrderModule,
                ContentLoggedOutModule,
                Ng2BootstrapModule,
                ChartsModule,
                SlimLoadingBarModule,
                FeaturesModule,
                DashboardModule,
                SharedModule
            ],
            declarations: [
                AppComponent,
                ContentComponent,
                NavigationComponent,
                FooterComponent,
                HelpComponent,
                QrComponent
            ],
            providers: [
                Title,
                //{provide: LocationStrategy, useClass: HashLocationStrategy},
                BrandsResolver,
                CountriesResolver,
                CookieService,
                MixpanelService,
                LocalStorageService,
                CurrentOrderService,
                OrderService,
                { provide: ErrorHandler, useClass: RavenErrorHandler }
            ],
            bootstrap: [AppComponent]
        })
    ], AppModule);
    return AppModule;
}());
export { AppModule };
//# sourceMappingURL=app.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/app.module.js
// module id = 989
// module chunks = 0